// extracted by mini-css-extract-plugin
export var wysiwyg = "styles-module--wysiwyg--5TzUy";
export var pageVariant = "styles-module--pageVariant--MvSet";
export var wysiwygContent = "styles-module--wysiwygContent--j4I9-";
export var backAndForthRight = "styles-module--backAndForthRight--sVFfE";
export var wobbleRightAndLeft = "styles-module--wobbleRightAndLeft--uoTbz";
export var animateBg = "styles-module--animateBg--UiLgM";